export class ReturnStruct {
    public isError: boolean = false;
    public errorCode: number = 0;
    public errorDescription: string = "";
}